"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addContext;
function addContext(Component, contextTypes) {
    Component.contextTypes = Component.contextTypes || {};
    Object.assign(Component.contextTypes, contextTypes);

    return Component;
}


//////////////////
// WEBPACK FOOTER
// ./~/d2-ui/lib/component-helpers/addContext.js
// module id = 400
// module chunks = 0